import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { OverlayContainer } from "@angular/cdk/overlay";

@Injectable({
  providedIn: "root",
})
export class OverlayContainerService {
  private pushSource: Subject<any> = new Subject<any>();
  private popSource: Subject<any> = new Subject<any>();
  private renderer: Renderer2;
  public onPush$: Observable<any> = this.pushSource.asObservable();
  public onPop$: Observable<any> = this.popSource.asObservable();
  public class: string;

  constructor(
    private overlayContainer: OverlayContainer,
    private rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public push(value: any): void {
    this.pushSource.next(value);
  }

  public pop(): void {
    this.popSource.next(undefined);
  }

  public addClass(className: string): void {
    this.renderer.addClass(
      this.overlayContainer.getContainerElement(),
      className,
    );
  }

  public removeClass(className: string): void {
    this.renderer.removeClass(
      this.overlayContainer.getContainerElement(),
      className,
    );
  }
}
